<ng-progress></ng-progress>
<div class="main-container">
  <mat-toolbar color="primary" class="topbar-header telative">
    <div class="navbar-header">
      <app-header [sidenav]="leftSidenav"></app-header>
    </div>
  </mat-toolbar>

  <mat-sidenav-container class="sidenav-container" autosize>
    <mat-sidenav #leftSidenav mode="over" (click)="leftSidenav.toggle()">
      <app-nav-bar></app-nav-bar>
    </mat-sidenav>

    <mat-sidenav-content class="page-wrapper">
      <div class="page-content">
        <div class="product-breadcrumb">
          <!-- <app-breadcrumb></app-breadcrumb> -->
        </div>
        <router-outlet></router-outlet>
        <app-footer></app-footer>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
